"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSpecialPlan = exports.customerWithoutNulls = exports.validLegalEntity = exports.isInspectionRequired = exports.mustShowAllUnits = exports.coverageListWithout = exports.coverageForCode = exports.getEndorsementCoverages = exports.getEndorsementCoveragesForUnit = exports.getDeductibleCoverages = exports.getDeductibleCoveragesForUnit = exports.getRegularCoverages = exports.getRegularCoveragesForUnit = exports.getAllCoverages = exports.getValidTotal = exports.defaultUnitDriver = exports.defaultUnitEntity = exports.maskAndSortUnits = exports.defaultUnit = exports.collaborator = void 0;
var LegalEntity_1 = require("../../models/LegalEntity");
var QuotationUnit_1 = require("../../models/QuotationUnit");
// Constants
var coverageTypes_1 = require("../../constants/coverageTypes");
exports.collaborator = 'ASE';
/**
 * Returns the default unit for the quotation
 *
 * @param quotation - The quotation where the unit will be extracted
 */
function defaultUnit(quotation) {
    var firstUnit = quotation.units[0];
    if (quotation.units.length === 1) {
        return firstUnit;
    }
    var foundUnit = quotation.units.find(function (unit) { return unit.package.id === quotation.packageOption; });
    if (foundUnit) {
        return foundUnit;
    }
    if (quotation.units.length > 1 &&
        quotation.packageOption === -1 &&
        quotation.hasMultipleOptions) {
        return firstUnit;
    }
    return QuotationUnit_1.makeEmptyQuotationUnit();
}
exports.defaultUnit = defaultUnit;
/**
 * Several screens need to hide the real unit package name, instead only showing the
 * the first package name between parenthesis (not sure why, design requirements).
 *
 * Note that the "slice" method allows us to call sort in a frozen array
 *
 * @param quotation - The quotation where the units will be extracted
 */
function maskAndSortUnits(quotation) {
    return quotation.units
        .slice()
        .sort(function (a, b) { return b.total.grandTotal - a.total.grandTotal; })
        .map(function (unit, index) {
        var additionalDesc = unit.package.isDefault
            ? "(ASSA Recomienda)"
            : '';
        return __assign(__assign({}, unit), { package: __assign(__assign({}, unit.package), { description: "Opci\u00F3n " + (index + 1) + " " + additionalDesc }) });
    });
}
exports.maskAndSortUnits = maskAndSortUnits;
/**
 * This will return the internal entity inside the default unit.
 *
 * @param quotation - The quotation to check
 */
function defaultUnitEntity(quotation) {
    return defaultUnit(quotation).unit;
}
exports.defaultUnitEntity = defaultUnitEntity;
/**
 * Returns the driver for the default unit in the provided quotation
 *
 * @param quotation - The quotation where the driver will be extracted
 */
function defaultUnitDriver(quotation) {
    return defaultUnit(quotation).unit.driver;
}
exports.defaultUnitDriver = defaultUnitDriver;
/**
 * Returns the total for the quotation's default unit.
 *
 * @param quotation - The source quotation
 */
function getValidTotal(quotation) {
    return defaultUnit(quotation).total;
}
exports.getValidTotal = getValidTotal;
/**
 * Returns the coverage list for the quotation
 * Note that the coverages present in the quotation are of type SimplifiedCoverage,
 * instead of regular Coverage
 *
 * @param quotation - The quotation where the coverages will be extracted
 */
function getAllCoverages(quotation) {
    return defaultUnit(quotation).coverages;
}
exports.getAllCoverages = getAllCoverages;
/**
 * Returne the list of regular coverages for the provided unit
 *
 * @param unit - the source unit
 * @param coverageResumeData - the list of coverage resumes
 */
function getRegularCoveragesForUnit(unit, coverageResumeData) {
    return unit.coverages.filter(function (cov) {
        var filteredResumes = coverageResumeData.filter(function (curData) {
            return (curData.code === cov.coverageId && curData.type !== coverageTypes_1.ENDORSEMENT_TYPE);
        });
        return filteredResumes.length > 0;
    });
}
exports.getRegularCoveragesForUnit = getRegularCoveragesForUnit;
/**
 * Returns a list of simplified coverages identified by the "C" type
 *
 * @param quotation - The quotation where the coverages will be extracted
 * @param coverageResumeData - The list of coverage resumes
 */
function getRegularCoverages(quotation, coverageResumeData) {
    return getRegularCoveragesForUnit(defaultUnit(quotation), coverageResumeData);
}
exports.getRegularCoverages = getRegularCoverages;
/**
 * Returne the list of deductible coverages for the provided unit
 *
 * @param unit - the source unit
 * @param coverageResumeData - the list of coverage resumes
 */
function getDeductibleCoveragesForUnit(unit, coverageResumeData) {
    return unit.coverages.filter(function (cov) {
        var filteredResumes = coverageResumeData.filter(function (curData) {
            return (curData.code === cov.coverageId &&
                curData.type !== coverageTypes_1.ENDORSEMENT_TYPE &&
                curData.applyDeductible);
        });
        return filteredResumes.length > 0;
    });
}
exports.getDeductibleCoveragesForUnit = getDeductibleCoveragesForUnit;
/**
 * Returns a list of simplified coverages that contain resumes
 *
 * @param quotation - The quotation where the coverages will be extracted
 * @param coverageResumeData - The list of coverage resumes
 */
function getDeductibleCoverages(quotation, coverageResumeData) {
    return getDeductibleCoveragesForUnit(defaultUnit(quotation), coverageResumeData);
}
exports.getDeductibleCoverages = getDeductibleCoverages;
/**
 * Returne the list of deductible coverages for the provided unit
 *
 * @param unit - the source unit
 * @param coverageResumeData - the list of coverage resumes
 */
function getEndorsementCoveragesForUnit(unit, coverageResumeData) {
    return unit.coverages.filter(function (cov) {
        var filteredResumes = coverageResumeData.filter(function (curData) {
            return (curData.code === cov.coverageId && curData.type === coverageTypes_1.ENDORSEMENT_TYPE);
        });
        return filteredResumes.length > 0;
    });
}
exports.getEndorsementCoveragesForUnit = getEndorsementCoveragesForUnit;
/**
 * Returns a list of simplified coverages that are identified as endorsement
 *
 * @param quotation - The quotation where the coverages will be extracted
 * @param coverageResumeData - The coverage resume list
 */
function getEndorsementCoverages(quotation, coverageResumeData) {
    return getEndorsementCoveragesForUnit(defaultUnit(quotation), coverageResumeData);
}
exports.getEndorsementCoverages = getEndorsementCoverages;
/**
 * Returns a Simplified coverage, identified by the provided code.
 * If nothing is found, returns undefined.
 *
 * @param simpCoverages - The list of simplified coverages
 * @param code - the code to search for
 */
function coverageForCode(quotationCoverages, code) {
    return quotationCoverages
        .filter(function (cov) { return cov.coverageId === code; })
        .pop();
}
exports.coverageForCode = coverageForCode;
/**
 * Returns a list that excludes the provided coverage (if present).
 * will not change anything if the coverage is not inside the list.
 *
 * @param simplifiedCoverages - The list to filter
 * @param code - The code to remove
 */
function coverageListWithout(simplifiedCoverages, code) {
    return simplifiedCoverages.filter(function (curCov) { return curCov.coverageId !== code; });
}
exports.coverageListWithout = coverageListWithout;
/**
 * If the quotation must display multiple options, this method will return true
 * Now this method will return true only when hasMultipleOptions is true without validating the package option value.
 *
 * @param quotation - The quotation to check
 */
function mustShowAllUnits(quotation) {
    return quotation.hasMultipleOptions;
}
exports.mustShowAllUnits = mustShowAllUnits;
/**
 * Helper function to verify if new vehicles need inspection.
 * Only requires inspection if vehicle is not new and inspectionRequired is true
 *
 * @param quotation
 * @param inspectionRequired inspection requirement to check new vehicle against with
 */
function isInspectionRequired(quotation, inspectionRequired) {
    if (!inspectionRequired) {
        return false;
    }
    // extracts vehicle unit's new status from quotation
    var isNewCar = defaultUnit(quotation).unit.isNewCar;
    return !isNewCar && inspectionRequired;
}
exports.isInspectionRequired = isInspectionRequired;
/**
 * Since legal entity can be null, we need this check here
 *
 * @param quotation - The source quotation
 */
function validLegalEntity(quotation) {
    return quotation.legalEntity || LegalEntity_1.makeEmptyLegalEntity();
}
exports.validLegalEntity = validLegalEntity;
/**
 * Since the quotation can return a customer with null values instead of the defined string
 * types, we need to take that into account.
 *
 * @param quotation - The source quotation
 */
function customerWithoutNulls(quotation) {
    var customer = quotation.customer;
    return {
        identifier: customer.identifier || '',
        firstName: customer.firstName || '',
        lastName: customer.lastName || '',
        birthday: customer.birthday || '',
        gender: customer.gender || '',
        address: customer.address || '',
        email: customer.email || '',
        phone: customer.phone || '',
        id: customer.id || '',
        idType: customer.idType || '',
    };
}
exports.customerWithoutNulls = customerWithoutNulls;
// Every Default Vehicle and Bremen
function isSpecialPlan(profile) {
    return profile.id > 3 && profile.id !== 11 && profile.id !== 31;
}
exports.isSpecialPlan = isSpecialPlan;
//# sourceMappingURL=quotationMethods.js.map